import { getApiUrl, tokenInterceptor, paramsSerializer } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const centersApi = createApi({
  reducerPath: 'centersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/centers'),
    prepareHeaders: tokenInterceptor,
    paramsSerializer,
  }),
  tagTypes: ['Centers'],
  endpoints: (builder) => ({
    centers: builder.mutation({
      query: (obj) => ({
        url: ``,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['Centers'],
    }),
  }),
});

export const { useCentersMutation } = centersApi;
